import { render, staticRenderFns } from "./newrv.vue?vue&type=template&id=7d257754&scoped=true&"
import script from "./newrv.vue?vue&type=script&lang=js&"
export * from "./newrv.vue?vue&type=script&lang=js&"
import style0 from "./newrv.vue?vue&type=style&index=0&id=7d257754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d257754",
  null
  
)

export default component.exports